'use client';

import { memo as Memo } from 'react';

//* Components
import Page from '@components/global/Page';
import Text from '@components/global/Text';
import SocIcon from '@components/global/SocIcon';
import Translate from '@components/global/Translate';
import Subscribe from '@components/global/Subscribe';
import HTMLContainer from '@components/global/HTMLContainer';
import ContentBuilder from '@components/cfModules/ContentBuilder';
import BlogListItem from '@components/cfModules/BlogList/BlogListItem';
import IndividualTopSection from '@components/global/IndividualTopSection';

//* Styles
import BlogIndividualStyle from '@/styles/pages/BlogIndividualStyle';

const BlogIndividual = Memo(({ pageData }) => {
	return (
		<Page>
			<BlogIndividualStyle>
				<IndividualTopSection
					underline
					title={pageData.fields.title}
					time={pageData.fields.readTime}
					category={pageData.fields.category}
					createdAt={pageData.fields.createdAt}
					innerCategory={pageData.fields.innerCategory}
					image={{
						url: pageData.fields.bannerImage.fields.file.url,
						alt: pageData.fields.bannerImage.fields.title,
					}}
				/>

				<HTMLContainer className={'blogSingleCont'}>
					<div className={`contentWrapper section-item`}>
						<ContentBuilder
							className={'imageWrap'}
							data={pageData.fields.content}
						/>

						<div className={`p Author font-regular`}>
							<Text className={'p-m font-poppins font-regular'}>
								<Translate val={'by'} />
							</Text>
							&nbsp;
							<Text className={'p-m font-poppins font-semi-bold font-italic'}>
								{pageData.fields.createdBy}
							</Text>
						</div>

						<SocIcon type={1} />
					</div>
				</HTMLContainer>

				<HTMLContainer>
					<Text
						tag={'h2'}
						className={`h2 font-poppins font-semi-bold title`}>
						<Text
							tag={'span'}
							className='item-1'>
							<Translate val={'read'} />
						</Text>
						&nbsp;
						<Text
							tag={'span'}
							className='item-2'>
							<Translate val={'nextBlog'} />
						</Text>
					</Text>
				</HTMLContainer>

				<BlogListItem
					createdAtr={pageData.nextPost.fields}
					url={`/blog/${pageData.nextPost.fields.slug}/`}
				/>
				<Subscribe />
			</BlogIndividualStyle>
		</Page>
	);
});

export default BlogIndividual;
